<template>
    <module-card :nextFunction="unlockResources">
        <p>
            <strong>HIV is not the same as AIDS.</strong> HIV stands for Human Immunodeficiency Virus. HIV makes a person’s immune system weak by killing cells that fight disease. Over time, HIV can destroy so many cells that the body can’t
            fight infections.
        </p>
        <v-img class="mx-auto" :max-width="200" :src="require('@/assets/hiv/cellDestruction.gif')" alt="Cell destruction"></v-img>
        <p>These “opportunistic” infections take advantage of a very weak immune system and are a sign that someone has AIDS or Acquired Immunodeficiency Syndrome, the last stage of HIV infection.</p>
        <p>Click to learn more about HIV: <external-link href="https://www.cdc.gov/hiv/basics/whatishiv.html" target="_blank">https://www.cdc.gov/hiv/basics/whatishiv.html</external-link></p>
    </module-card>
</template>

<script>
    import { sync } from 'vuex-pathify';
    import { forEach } from 'lodash';

    export default {
        computed: {
            resources: sync('resources')
        },
        methods: {
            unlockResources() {
                // unlock alcohol and marijuana resources
                forEach(this.resources, (o) => {
                    if (o.category === 'HIV' && o.topic === 'HIV') {
                        o.unlocked = true;
                    }
                });
            }
        }
    };
</script>
